import qs from 'qs';
import request from '../request';
import { API } from '../../../global-constants';

const create = content =>
  request({
    baseURL: API.BASE_URL,
    url: API.AGENT_COMMISSION_ELABORATION,
    method: 'POST',
    data: content,
  });

const read = id =>
  request({
    baseURL: API.BASE_URL,
    url: `${API.AGENT_COMMISSION_ELABORATION}/${id}`,
    method: 'GET',
  });

const update = content =>
  request({
    baseURL: API.BASE_URL,
    url: `${API.AGENT_COMMISSION_ELABORATION}/${content.id}`,
    method: 'PUT',
    data: content,
  });

const remove = id =>
  request({
    baseURL: API.BASE_URL,
    url: `${API.AGENT_COMMISSION_ELABORATION}/${id}`,
    method: 'DELETE',
  });

const getAll = () =>
  request({
    baseURL: API.BASE_URL,
    url: API.AGENT_COMMISSION_ELABORATION,
    method: 'GET',
    params: {},
  });

const exportData = id =>
  request({
    baseURL: API.BASE_URL,
    url: API.EXPORT_EXCEL,
    method: 'POST',
    responseType: 'blob',
    data: { method: 'export-excel', params: { commissionId: id } },
  });

const exportPDF = filter =>
  request({
    baseURL: API.BASE_URL,
    url: API.AGENT_COMMISSION_EXPORT_PDF,
    method: 'GET',
    responseType: 'blob',
    params: {
      filter,
    },
    paramsSerializer: params => qs.stringify(params),
  });

const exportExcel = filter =>
  request({
    baseURL: API.BASE_URL,
    url: API.EXPORT_EXCEL,
    method: 'POST',
    responseType: 'blob',
    data: {
      method: 'export-excel',
      params: {
        code: '002',
        ...filter,
      },
    },
  });

const getCommissionsLogs = (id, page) =>
  request({
    baseURL: API.BASE_URL,
    url: `${API.ORDER_ROW_LOGS}`,
    method: 'GET',
    params: {
      page: page || 1,
      pageSize: 5,
      filter: [
        {
          type: 'eq',
          field: 'objectId',
          value: id,
        },
      ],
    },
    paramsSerializer: params => qs.stringify(params),
  });

const AgenCommissionElaborationService = {
  create,
  read,
  update,
  remove,
  getAll,
  exportData,
  exportPDF,
  exportExcel,
  getCommissionsLogs,
};

export default AgenCommissionElaborationService;
